import React from 'react';

import {DropzoneInputProps, DropzoneRootProps} from 'react-dropzone';

import {ReactComponent as UploadIcon} from 'assets/svg/download.svg';

import {Icon} from 'components/ui-kit/Icon';

import {Switch} from 'components/ui-kit/Switcher';

import {
    Root,
    HighlightedText,
    FileExample,
    ModalContent,
    RootContent,
    ModalContentWrapper,
} from '../styled';

interface ModalContentBodyProps {
    isDragActive: boolean;
    getRootProps: (props?: DropzoneRootProps) => DropzoneRootProps;
    getInputProps: (props?: DropzoneInputProps) => DropzoneInputProps;
    isProcessing: boolean;
    file: File | null;
    t: (key: string) => string;
    GEN_INFO: string;
    combineByGtin: boolean;
    setCombineByGtin: (value: boolean) => void;
}
export const ModalContentBody = ({
    isDragActive,
    getRootProps,
    getInputProps,
    isProcessing,
    file,
    t,
    GEN_INFO,
    combineByGtin,
    setCombineByGtin,
}: ModalContentBodyProps) => (
    <ModalContent>
        <ModalContentWrapper>
            <Root isDrag={isDragActive} {...getRootProps()}>
                <input {...getInputProps()} />
                {isDragActive ? (
                    <p>{t('pages.dashboard.dragHere')}</p>
                ) : file ? (
                    <RootContent>
                        {isProcessing && <div>{t(`${GEN_INFO}.fileProcessing`)}</div>}
                    </RootContent>
                ) : (
                    <RootContent>
                        <Icon source={UploadIcon} width={16} height={16} />
                        <p>
                            <HighlightedText>{t(`${GEN_INFO}.dragAndDrop`)}</HighlightedText>{' '}
                            {t(`${GEN_INFO}.aFileHere`)}{' '}
                            <HighlightedText>{t(`${GEN_INFO}.chooseFile`)}</HighlightedText>
                        </p>
                    </RootContent>
                )}
            </Root>
            <FileExample>
                <span>{t(`${GEN_INFO}.needHelp`)}</span>
                <a download={'invoices_template.xlsx'} href="/examples/invoices_template.xlsx">
                    {t(`${GEN_INFO}.downloadTemplate`)}
                </a>
            </FileExample>
        </ModalContentWrapper>
        <Switch
            width="100%"
            value={combineByGtin}
            label="Combine products by GTIN into 1 line"
            onChange={() => setCombineByGtin(!combineByGtin)}
        />
    </ModalContent>
);
